import { Spinner } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { friends } from '../../../../commons/redux/actions/admin.action'
import TagCustom from '../ServicesDemand/tag'
import ItemPartenaireAccept from './item_accept'
import './styles.css'
export default function PartenaireAccept() {
  const adminReducer = useSelector((state) => state.adminReducer)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(friends())
  }, [dispatch])

  return (
    <div>
      <div className="mt-2">
        <div className=" col-sm-12 -auto bg-white">
          {' '}
          <div className="p-3 flex gap-2">
            <h2 className="text-2xl font-bold"> Nos partenaires</h2>
            <p className="bg-gray-100 rounded-full text-center font-bold h-10 w-10 p-1 text-xl">
              {adminReducer.item?.length ? adminReducer.item.length : 0}
            </p>
          </div>
          <div className="flex flex-wrap p-3">
            {!adminReducer.item ? (
              <div className="mx-auto text-center">
                <Spinner
                  thickness="4px"
                  speed="0.65s"
                  emptyColor="gray.200"
                  color="blue.500"
                  size="xl"
                />{' '}
              </div>
            ) : (
              <>
                {adminReducer?.item?.length === 0 ? (
                  <div>
                    <div className="text-4xl text-gray-300 font-bold ">
                      <h2>Vous n'avez aucun partenaire pour le moment.</h2>
                    </div>
                  </div>
                ) : (
                  <table>
                    <tr>
                      <th> Nom</th>
                      <th> Tel</th>
                      <th> Competence</th>
                      <th> Ville</th>
                      <th>
                        Quartier
                      </th>
                      <th> Medias</th>
                      <th> Retirer</th>

                    </tr>
                    {adminReducer.item.map((value, index) => {
                      return (
                        <tr>
                          <td>{value.name}</td>
                          <td>{value.tel}</td>
                          <td>{value.skill}</td>
                          <td>{value.town}</td>
                          <td>{value.district}</td>
                          <td>
                            <a href={`/${value?.some_document}`}>Mes documents</a>
                          </td>
                          <td><button className='btn btn-sm btn-danger text-center '>Retirer</button></td>
                        </tr>
                      )
                    })}
                  </table>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
